import { render, staticRenderFns } from "./BDXNewCoverholderForm.vue?vue&type=template&id=69a6dde4"
import script from "./BDXNewCoverholderForm.vue?vue&type=script&lang=js"
export * from "./BDXNewCoverholderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports